import React from 'react';

const NotAdmin = () => {
    return (
        <div className="centerized-text flex-column">
            <h4>You Are Not an Admin</h4>
            <p>If you are an admin please log-in with your admin creditials</p>
        </div>
    );
};

export default NotAdmin;